var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './Model';
import * as Atlas from "azure-maps-control";
var LocationSampleModel = /** @class */ (function (_super) {
    __extends(LocationSampleModel, _super);
    function LocationSampleModel(data) {
        var _this = _super.call(this, data) || this;
        _this.firstCoordinateString = _this.firstLat + ',' + _this.firstLong;
        _this.lastCoordinateString = _this.lastLat + ',' + _this.lastLong;
        return _this;
    }
    LocationSampleModel.prototype.isCoordinate = function () {
        return !(this.firstLong === 0 && this.firstLat === 0);
    };
    LocationSampleModel.prototype.getFirstCoordinates = function () {
        return (this.firstLong === 0 && this.firstLat === 0) ? null : [this.firstLong, this.firstLat];
    };
    LocationSampleModel.prototype.getLastCoordinates = function () {
        return (this.lastLong === 0 && this.lastLat === 0) ? null : [this.lastLong, this.lastLat];
    };
    LocationSampleModel.prototype.getFirstPlaceGoogleMapsUrl = function () {
        return this.firstPlace ? 'https://www.google.com/maps/search/?api=1&query=' + this.firstLat + ',' + this.firstLong : null;
    };
    LocationSampleModel.prototype.getLastPlaceGoogleMapsUrl = function () {
        return this.lastPlace ? 'https://www.google.com/maps/search/?api=1&query=' + this.lastLat + ',' + this.lastLong : null;
    };
    LocationSampleModel.prototype.getShape = function () {
        var first = this.getFirstCoordinates();
        var last = this.getLastCoordinates();
        if (!first || !last) {
            return null;
        }
        return new Atlas.data.LineString([first, last]);
    };
    return LocationSampleModel;
}(Model));
export default LocationSampleModel;
